export default __webpack_public_path__ + "static/media/reg_2.9bf67750.jpg";